import { useQueryClient } from '@tanstack/react-query';
import { Col, Modal, Row } from 'antd';
import { klwAxios, setKringloopwijzerId } from 'helpers/api';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import styles from '../components.module.scss';

export enum UserRole {
  VEEHOUDER = 1,
  ADVISEUR = 2,
}

export const useChoiceModal = () => {
  const [visible, setVisible] = useState(false);
  const nav = useNavigate();
  const qc = useQueryClient();
  const setRole = (role: number) => {
    klwAxios.defaults.headers.common['gekozen-rol'] = role;
    if (role !== UserRole.VEEHOUDER) {
      nav('/');
      setKringloopwijzerId(undefined);
      localStorage.clear();
      localStorage.setItem('klw_was_active', '1');
      klwAxios.defaults.headers.common['Kvk-Proxy'] = undefined;
      qc.invalidateQueries();
    }

    setVisible(false);
  };

  const component = (
    <Modal
      open={visible}
      onCancel={() => setRole(UserRole.ADVISEUR)}
      footer={null}
      closable
      title="Kies een rol"
      centered
      width={500}
      className={styles.choiceModal}>
      <p>
        De gebruiker waarmee u bent ingelogd kent verschillende rollen. Maak aub uw keuze door te klikken op veehouder of adviseur. Als u het scherm sluit [x]
        dan gaat u verder als adviseur.
      </p>

      <button className={styles.rolChoice} style={{ width: '100%' }} onClick={() => setRole(UserRole.VEEHOUDER)}>
        <Row align="middle">
          <Col flex="60px">
            <img src="/veehouder.png" alt="Veehouder" />
          </Col>
          <Col>
            <p className={styles.rolTitle}>Veehouder</p>
          </Col>
        </Row>
      </button>

      <button className={styles.rolChoice} style={{ width: '100%' }} onClick={() => setRole(UserRole.ADVISEUR)}>
        <Row align="middle">
          <Col flex="60px">
            <img src="/adviseur.png" alt="Adviseur" />
          </Col>
          <Col>
            <p className={styles.rolTitle}>Adviseur</p>
          </Col>
        </Row>
      </button>
    </Modal>
  );
  return { component, openModal: () => setVisible(true) };
};
